import React from "react";
import moment from "moment";
import Barcode from "react-barcode";

const CustomLabel = React.forwardRef(({ order }, ref) => {
  // const formattedAWB = (order?.awb_number || "000000000")
  //   .split("")
  //   .join("\u200A");
  return (
    <div
      ref={ref}
      style={{
        width: "285px",
        // border: "1px solid black",
        paddingTop: "11px",
        paddingBottom: "11px",
        paddingLeft: "14px",
        paddingRight: "14px"
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", }}>

        <div style={{ display: "flex", alignItems: "center", paddingBottom: '6px' }}>
          {/* <img src={logo512} className="h-7 w-7" alt="AlgarXpress Logo" /> */}
          <img
            src="/logo192.png"
            className="h-10 w-10 mt-2"
            alt="AlgarXpress Logo"
          />

          <div>
            <p style={{ fontSize: "11px", fontWeight: "bold", paddingLeft: "8px", }} className="mb-">
              AlgarXpress
            </p>
            <p style={{ fontSize: "8px", paddingLeft: "8px", fontWeight: "bold" }} className="mb-">
              Prepaid | Cash on Delivery | International | www.algarxpress.com
              {/* India’s Largest Logistics Network – Fast & Reliable Shipping | www.algarxpress.com */}
            </p>
          </div>

        </div>


        <div style={{ paddingBottom: '8px' }}>

          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            {order?.deliveryAddress?.name}  <span style={{ fontSize: "8px", fontWeight: "bold", paddingLeft: '6px' }}>(To)</span>
          </p>
          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            {order?.deliveryAddress?.address1},
          </p>
          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            {order?.deliveryAddress?.city}, {order?.deliveryAddress?.stateId?.name} - {order?.deliveryAddress?.zipCode}
          </p>
          <p style={{ fontSize: "8px", marginTop: 0 }}>
            Mobile No. <span style={{ fontSize: "8px", fontWeight: "bold" }}>{order?.deliveryAddress?.phone} {order?.deliveryAddress?.alternateMobileNumber ? `| ${order?.deliveryAddress?.alternateMobileNumber}` : ""}</span>
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTop: "1px solid black",
            borderBottom: "1px solid black",
            width: "100%",
            // padding: "6px 0", // Added padding for better spacing
          }}
        >
          {/* COD and Price Box */}
          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center" }} className="pb-4">
            <span style={{ fontSize: "14px", fontWeight: "bold" }}> {order?.payment_type === 'COD' ? "COD" : "PREPAID"}</span>
            {order?.payment_type === "COD" ? <span style={{ fontSize: "14px", fontWeight: "bold", paddingLeft: "16px" }}>
              {order?.codCollectableValue}
            </span> : ""}
          </div>

          {/* Barcode & AWB Number Box */}
          <div style={{
            flex: 1, display: "flex", flexDirection: "column", alignItems: "center", border: "none",
            outline: "none",
            boxShadow: "none"
          }} className="-mt-2 -mb-2">
            {/* Barcode */}
            <div style={{ display: "flex", gap: "2px", justifyContent: "center" }}>
              <Barcode
                value={order?.order_number || "000000000"}
                format="CODE128"
                width={0.8}
                height={20}
                displayValue={true}
                fontSize={9}
                margin={0}

              />
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center", // Fixed camelCase
            width: "100%",
          }}
        >
          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            Order No: <span style={{ fontSize: "8px", fontWeight: "bold" }}>{order?.order_number}</span>
          </p>
          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            Order Date:  <span style={{ fontSize: "8px", fontWeight: "bold" }}> {moment(order?.createdAt).format("MMM DD, YYYY")}</span>
          </p>
        </div>

        <div style={{ width: "100%" }}>
          <p style={{ fontSize: "8px" }}>
            <span style={{ fontWeight: "bold" }}>Fwd Destination Code:</span>{" "}
            {order?.deliveryAddress?.stateId?.name?.toUpperCase() || "N/A"}
          </p>
          <p style={{ fontSize: "8px" }}>
            <span style={{ fontWeight: "bold" }}>Category: AlgarXpress</span>
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", paddingTop: '10px' }}>
          <div style={{ display: "flex", gap: "2px", letterSpacing: "0.3px", }}>
            <Barcode
              value={order?.awb_number || "000000000"}
              format="CODE128"
              width={1.5}
              height={30}
              displayValue={true}
              fontSize={11}
              margin={0}
              fontOptions="bold"

            />
          </div>
        </div>

        <div style={{ width: "100%" }}>
          <h3 style={{ fontSize: "9px", fontWeight: "bold" }}>
            Product Details:
          </h3>
          {/* <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              border: "1px solid black",
              textAlign: "center",
              verticalAlign: "middle",
              fontSize: "8px",
            }}
          >
            <thead>
              <tr>
                <th style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }} className="mb-4">SKU</th>
                <th style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }} className="mb-4">Item Name</th>
                <th style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }} className="mb-4">Qty.</th>
                <th style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }} className="mb-4">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }}>
                  {order?.awb_number || "N/A"}
                </td>
                <td style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }}>
                  {order?.ProductName || "N/A"}
                </td>
                <td style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }}>1</td>
                <td style={{ borderTop: "1px solid black", textAlign: "center", verticalAlign: "middle", }}>
                  {order?.ProductPrice || "0.00"}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    borderTop: "1px solid black",

                    fontWeight: "bold",
                    textAlign: "center", verticalAlign: "middle",
                  }}
                  colSpan={2}
                ></td>
                <td
                  style={{
                    borderTop: "1px solid black",

                    fontWeight: "bold",
                    textAlign: "center", verticalAlign: "middle"
                  }}
                >
                  Order Total
                </td>
                <td
                  style={{
                    borderTop: "1px solid black",

                    fontWeight: "bold",
                    textAlign: "center", verticalAlign: "middle"
                  }}
                >
                  {order?.ProductPrice || "0.00"}
                </td>
              </tr>
            </tbody>
          </table> */}


          <div style={{ width: "100%", marginBottom: '8px' }}>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // Fixed camelCase
                width: "100%",
              }}
            >
              <p style={{ fontSize: "8px", fontWeight: "bold" }}>
                <span >SKU : </span>{" "}
                {order?.awb_number || "N/A"}
              </p>
              <p style={{ fontSize: "8px" }}>
                <span style={{ fontWeight: "bold" }}>Box Qty :</span>{" "}
                1
              </p>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // Fixed camelCase
                width: "100%",
              }}
            >
              <p style={{ fontSize: "8px", fontWeight: "bold" }}>
                <span >Item Name:</span>   {order?.ProductName || "N/A"}
              </p>

              <p style={{ fontSize: "8px" }}>
                <span style={{ fontWeight: "bold" }}>Order Total :</span>   {order?.ProductPrice || "0.00"}
              </p>
            </div>


          </div>
        </div>

        <div style={{ borderTop: '1px solid black', width: "100%" }}>
          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            {order?.pickupAddress?.name} <span style={{ fontSize: "8px", fontWeight: "normal" }}>(Pickup and Return Address)</span>
          </p>
          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            {order?.pickupAddress?.address1},
          </p>
          <p style={{ fontSize: "8px", fontWeight: "bold" }}>
            {order?.pickupAddress?.city}, {order?.pickupAddress?.stateId?.name} - {order?.pickupAddress?.zipCode}
          </p>
          <p style={{ fontSize: "8px" }}>Mobile No. <span style={{ fontSize: "8px", fontWeight: 'bold' }}> {order?.pickupAddress?.phone}</span></p>

        </div>
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end", // 👈 text right side align
          width: "100%"
        }}>
          <p style={{ fontSize: "7px", fontWeight: "bold" }}>Customer Support Number</p>

          {/* 10. Phone Number */}
          <p style={{ fontSize: "7px", margin: "0", fontWeight: "bold", }}>Email : algarxpress@gmail.com</p>
          <p style={{ fontSize: "7px", margin: "0", fontWeight: "bold", }}>022-2886-24916 (MUMBAI)</p>


        </div>
      </div>
    </div >
  );
});

export default CustomLabel;